import { updateOrganization } from 'api/organizations.api';
import { fetchAndSetCompanySettingsData } from 'components/views/FounderSettings/_helpers/founderSettings.resolvers';
import { $form, $user, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';
import displayNotification from 'utils/displayNotification';
import getSelectValue from 'utils/getSelectValue';

export const handleSubmitCompanyEdit = async () => {
  $view.update({ isLoading: true });

  try {
    await updateOrganization(
      $user.value.organization.id,
      {
        name: $form.value.name,
        email: $form.value.email,
        website: $form.value.website,
        phone: $form.value.phone,
        isMainAddress: true,
        street: $form.value.street,
        city: $form.value.city,
        provinceCode: getSelectValue($form.value.provinceCode),
        countryCode: getSelectValue($form.value.countryCode),
        postalCode: $form.value.zip,
        addressId: $form.value.addressId,
        logoImage: $form.value.logoImage,
      },
    );
    displayNotification({
      message: 'Company info updated successfully',
      type: 'success',
    });
  } catch (error) {
    displayError({
      message: 'Failed to update company information. Please check your information and try again.',
      title: 'Company Update Error',
    });
  } finally {
    await fetchAndSetCompanySettingsData();
    $view.update({ isLoading: false });
  }
};

export const handleCompanyLogoUpload = async (imageUrl) => {
  try {
    $form.update({ logoImage: imageUrl });
    await updateOrganization($user.value.organization.id, {
      logoImage: imageUrl,
    });
    displayNotification({
      message: 'Company logo updated successfully!',
      title: 'Success',
    });
  } catch (error) {
    displayError({
      message: 'Failed to update company logo. Please try again.',
      title: 'Logo Update Error',
    });
    // Revert the form state on error
    $form.update({ logoImage: $user.value.organization?.logoImage });
  }
};

export const handleCompanyLogoRemove = async () => {
  try {
    $form.update({ logoImage: null });
    await updateOrganization($user.value.organization.id, {
      logoImage: null,
    });
    displayNotification({
      message: 'Company logo removed successfully!',
      title: 'Success',
    });
  } catch (error) {
    displayError({
      message: 'Failed to remove company logo. Please try again.',
      title: 'Logo Removal Error',
    });
    // Revert the form state on error
    $form.update({ logoImage: $user.value.organization?.logoImage });
  }
};
